/**
 * Single canonical localStorage key for the client's seen app bundle version.
 * Must stay aligned with preservation logic in `services/cacheManager` (`clearAppCache`).
 */
export const APP_VERSION_STORAGE_KEY = "rivet_app_version";

/** Previous key from an older hook — migrated on read */
export const LEGACY_APP_VERSION_STORAGE_KEY = "rivetai_app_version";

export function readStoredAppVersion(): string | null {
  try {
    const canonical = localStorage.getItem(APP_VERSION_STORAGE_KEY);
    if (canonical) return canonical;
    const legacy = localStorage.getItem(LEGACY_APP_VERSION_STORAGE_KEY);
    if (legacy) {
      localStorage.setItem(APP_VERSION_STORAGE_KEY, legacy);
      localStorage.removeItem(LEGACY_APP_VERSION_STORAGE_KEY);
      return legacy;
    }
    return null;
  } catch {
    return null;
  }
}

export function writeStoredAppVersion(version: string): void {
  try {
    localStorage.setItem(APP_VERSION_STORAGE_KEY, version);
    localStorage.removeItem(LEGACY_APP_VERSION_STORAGE_KEY);
  } catch {
    // Storage may be unavailable; caller treats as best-effort
  }
}
